import { createFileRoute } from "@tanstack/react-router";
import { Plane } from "lucide-react";

import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { InlineFlightSearch } from "@/components/site/InlineFlightSearch";

export const Route = createFileRoute("/flights")({
  head: () => ({
    meta: [
      { title: "Vuelos baratos a México y al mundo — Mostrando México" },
      {
        name: "description",
        content:
          "Compara cientos de aerolíneas y agencias en tiempo real. Encuentra vuelos a Cancún, CDMX, Tulum, Oaxaca y más.",
      },
      { property: "og:title", content: "Vuelos baratos — Mostrando México" },
      { property: "og:description", content: "Cientos de aerolíneas, un solo lugar." },
    ],
    links: [{ rel: "canonical", href: "https://www.mostrandomexico.mx/flights" }],
  }),
  component: FlightsPage,
});

function FlightsPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <section className="relative isolate overflow-hidden bg-gradient-to-br from-primary/10 via-background to-accent/40">
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(60%_50%_at_50%_0%,oklch(0.72_0.18_45/0.16),transparent_70%)]" />
        <div className="mx-auto max-w-7xl px-4 pb-12 pt-14 sm:px-6 lg:px-8 lg:pt-20">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-primary">
              <Plane className="h-3.5 w-3.5" /> Vuelos
            </span>
            <h1 className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight sm:text-5xl">
              Vuelos a precio referencial,
              <span className="block text-primary">sin sorpresas.</span>
            </h1>
            <p className="mt-3 max-w-xl text-base text-muted-foreground">
              Comparamos cientos de aerolíneas y agencias en tiempo real para que pagues lo justo.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-8">
        <InlineFlightSearch />
      </section>

      <SiteFooter />
    </div>
  );
}
